import { render, staticRenderFns } from "./HdsDialog.vue?vue&type=template&id=08cc36e9&scoped=true&"
import script from "./HdsDialog.vue?vue&type=script&lang=ts&"
export * from "./HdsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./HdsDialog.vue?vue&type=style&index=0&id=08cc36e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cc36e9",
  null
  
)

export default component.exports